<style lang="less">
@import "../../../styles/public/public.less";
@import "../less/showmodel.less";

.iview .ivu-input,
.iview .ivu-select-selection {
    border: 1px solid #17708e !important;
    background-color: #0f2d47 !important;
}

.commentsty {
    width: 100%;
    resize: none;
    background: #9CB3C3;
    color: #fff;
    border: 1px solid #17708e;
    padding: 8px;
}
</style>
<template>
<div class="showmodel">
    <div class="showmodel_1 display_wrap_as set_yj">
        <titles titles="用户编辑"></titles>
        <div v-for="item in editInfo" :key="item.name" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>{{item.name}}:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <Input v-model="item.value" :type="item.boxtype" :placeholder="'请输入'+item.name" style="width: 100%" />
            </div>
        </div>
        <div v-show="showunit" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>所属单位:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <Select v-model="user.unitcode" style="width: 100%">
                    <Option v-for="item in unitList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>出生年月:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <DatePicker v-model="user.birthday" :start-date="new Date(1960, 1, 1)" type="date" placeholder="选择日期" style="width: 100%"></DatePicker>
            </div>
        </div>
        <div class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>性别:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <Select v-model="user.genderIndex" style="width: 100%">
                    <Option v-for="item in genderList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div v-show="showexpert" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>是否专家库成员:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <Select v-model="user.ismemberIndex" style="width: 100%">
                    <Option v-for="item in isexpertList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div style="margin-top:10px;" class="showmodel_2hz display_row_ac media_w_showmodel2hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>备注:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11">
                <textarea v-model="user.REMARK" class="commentsty" cols="30" rows="3"></textarea>
            </div>
        </div>
        <div style="margin-top:10px;" class="showmodel_1hz display_row_je media_w_showmodel2hz">
            <Button type="success" @click="checkUser">保存</Button>
        </div>
    </div>
</div>
</template>

<script>
import titles from "../../pages/title.vue";
import bus from "../../../app/event";
export default {
    components: {
        titles
    },
    data() {
        return {
            value: "",
            user: {},
            disabled: false,
            gender: "",
            genderList: [{
                    value: 0,
                    label: "男"
                },
                {
                    value: 1,
                    label: "女"
                }
            ],
            isadmin: "",
            isadminList: [{
                    value: 1,
                    label: "是"
                },
                {
                    value: 0,
                    label: "否"
                }
            ],
            isexpert: 1,
            isexpertList: [{
                    value: 1,
                    label: "是"
                },
                {
                    value: 0,
                    label: "否"
                }
            ],
            showexpert: false,
            unitid: "",
            unitList: [],
            birthday: "",
            showunit: true,
            editInfo: [{
                    name: "用户账号",
                    value: "",
                    type: "account",
                    boxtype: "text"
                },
                {
                    name: "用户名称",
                    value: "",
                    type: "mc",
                    boxtype: "text"
                },
                {
                    name: "用户密码",
                    value: "",
                    type: "password",
                    boxtype: "password"
                },
                {
                    name: "确认密码",
                    value: "",
                    type: "password",
                    boxtype: "password"
                },
                // {
                //   name:'性别',
                //   value:'',
                //   type:'gender',
                // },
                {
                    name: "联系电话",
                    value: "",
                    type: "dh",
                    boxtype: "text"
                },
                {
                    name: "邮箱",
                    value: "",
                    type: "postcode",
                    boxtype: "text"
                }
                // {
                //   name:'所属单位编号',
                //   value:'',
                //   type:'unitcode',
                // },
                // {
                //   name:'是否管理员',
                //   value:'',
                //   type:'isadmin',
                // },
                // {
                //   name:'出生年月',
                //   value:'',
                //   type:'birthday',
                // },
                // {
                //   name:'是否专家库成员',
                //   value:'',
                //   type:'ismember',
                // },
            ],
            flag: null,
            id: "",
            unitcodelist: [], //已经有管理员的单位列表
            copyunitcode:'',
        };
    },
    methods: {
         checkUser: function () {
            if (this.editInfo[2].value != this.editInfo[3].value) {
                this.$Message.warning("两次输入的密码不一致！");
                return;
            }
            if (this.flag) {
                //如果是修改操作跳过检查用户是否存在的操作
                this.checkadministrator();
                return;
            }
            let account = this.editInfo[0].value;
            this.$http
                .post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=IsExitUser", {
                        UserCode: account
                    }
                )
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.success == "true") {
                            this.$Message.warning("该账号已存在!");
                        } else {
                            this.checkadministrator();
                        }
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                });
        },
         checkadministrator: function () {
            if (this.flag) {
                let newcode = this.user.unitcode;
                //如果没修改单位则直接跳过重复检查
                if (newcode === this.copyunitcode) {
                    this.saveInfo();
                    return
                }
            }
            let data = {
                FILED: 'ID',
                TABLENAME: 'SYS_USER',
                SQLWHERE: `ssdw='${this.user.unitcode}' and aothor_id=1 and isadmin=1`
            }
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=generalsql", data
                )
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.length == 0) {
                            this.saveInfo();
                        } else {
                            this.$Message.warning('一个单位只能有一位管理员');
                        }
                    } else {
                        this.$Message.warning('校验失败')
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        saveInfo: function () {
            // await this.checkUser();
            // await this.checkadministrator();
            let birthday = typeof this.user.birthday == "string" ? this.user.birthday : this.formatDate(this.user.birthday);
            let username = this.editInfo[1].value;
            let account = this.editInfo[0].value;
            let userpassword = this.editInfo[2].value;
            let phonenum = this.editInfo[4].value;
            let email = this.editInfo[5].value;
            if (username == "" || username == undefined) {
                this.$Message.warning("用户名不能为空");
                return;
            }
            if (account == "" || account == undefined) {
                this.$Message.warning("用户账号不能为空");
                return;
            }
            if (userpassword == "" || userpassword == undefined) {
                this.$Message.warning("用户密码不能为空");
                return;
            }
            if (
                (this.user.unitcode == "" || this.user.unitcode == undefined) &&
                sessionStorage.getItem("AOTHOR_ID") == "0"
            ) {
                this.$Message.warning("所属单位不能为空");
                return;
            }
            //非园林局用户默认非专家
            if (
                this.user.ismemberIndex === "" ||
                this.user.ismemberIndex == undefined
            ) {
                //没选就给默认值
                this.user.ismemberIndex = "1";
            }
            let actype = this.flag ? "updateuser" : "saveuser";
            let data = {
                USERCODE: account,
                USERNAME: username,
                USERPASSWORD: userpassword,
                SEX: this.user.genderIndex,
                PHONE: phonenum,
                EMAIL: email,
                SSDW: sessionStorage.getItem("AOTHOR_ID") == "0" ? this.user.unitcode : sessionStorage.getItem("SSDW"),
                ISADMIN: sessionStorage.getItem("ISADMIN"),
                DATEOFBIRTH: birthday,
                EXPERT: this.user.ismemberIndex,
                REMARK: this.user.REMARK
            };
            this.flag ? data["ID"] = this.user.id : data["AOTHOR_ID"] = sessionStorage.getItem("AOTHOR_ID");
            this.$http
                .post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=" + actype,
                    data
                )
                .then(res => {
                    if (res.status == 200 && res.data.success == "true") {
                        let str = this.flag ? "修改用户成功" : "新建用户成功";
                        this.$Message.success(str);
                        bus.$emit("refreshuser"); //重新获取数据
                        this.reset();
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                });
        },
        //获取年月日
        formatDate: function (date) {
            if (date == undefined || date == "") {
                return "";
            }
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            let nowDate = year + "-" + month + "-" + day;
            return nowDate;
        },
        reset: function () {
            this.gender = "";
            this.isadmin = "";
            this.isexpert = "";
            this.birthday = "";
            this.editInfo.map(el => {
                el.value = "";
            });
        },
        getUnit() {
            this.$http
                .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=listorg", {
                    SSDW: sessionStorage.getItem("SSDW"),
                    AOTHOR_ID: sessionStorage.getItem("AOTHOR_ID")
                })
                .then(res => {
                    if (res.status == 200) {
                        this.unitList = [];
                        let rawData = res.data;
                        rawData.forEach(ele => {
                            let obj = {
                                value: ele.ID,
                                label: ele.DWMC
                            };
                            this.unitList.push(obj);
                        });
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                });
        }
    },
    mounted() {
        sessionStorage.getItem("AOTHOR_ID") == "0" ? this.getUnit() : (this.showunit = false);
        sessionStorage.getItem("AOTHOR_ID") == "-1" ? (this.showexpert = true) : null;
        // this.getUnit();
        let that = this;
        bus.$on("newuser", (showData, flag) => {
            that.editInfo.map((item, index) => {
                item.value = showData[item.type];
            });
            that.user = showData;
            that.flag = flag;
            that.copyunitcode=showData.unitcode;
        });
        bus.$on('checkunit', (data) => {
            this.unitcodelist = data;
        })
    },
    beforeDestroy() {
        bus.$off("newuser");
        bus.$off("checkunit");
    },
    directives: {}
};
</script>



// WEBPACK FOOTER //
// modifymodel.vue?dab051e0